import Vue from 'vue'
import Vuex from 'vuex'
import socketio from '@/store/socketio'
import Config from './config.js'
import socketFacturacionCL from '@/store/socketFacturacionCL'
import User from './user.js'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		apiBackend: '',
		auth: [],
		role: [],
		closeBtnEnable: false,
		commandGeneral: [],
		commandModule: [],
		commandSystem: [],
		container: 'container-fluid',
		environment: '',
		greeted: false,
		headers: {
			Accept: 'application/json',
			Authorization: ''
		},
		history: [],
		historyInput: [],
		iconClassLockScreen: 'spinner-border',
		initialized: false,
		io: {},
		menuLeft: [],
		messageLockScreen: 'Cargando . . .',
		socketioConnect: false,
		textColor: 'text-white',
		token: '',
		web: '',
		headerModule: {
			id: 0,
			titleModule: '',
			subTitleModule: '',
			favorite: false
		},
		
	},
	mutations: {
		setApiBackend(state, url) { state.apiBackend = url },
		setAuth(state, auth) { state.auth = auth },
		setCloseBtnEnableLockScreen(state, closeBtnEnable) { state.closeBtnEnable = closeBtnEnable },
		setCommandGeneral(state, commands) { state.commandGeneral = commands },
		setCommandModule(state, commands) { state.commandModule = commands },
		setCommandSystem(state, commands) { state.commandSystem = commands },
		setContainer(state, container) { state.container = container },
		setEnvironment(state, environment) { state.environment = environment },
		setFavorite(state, id) { state.headerModule.favorite = id },
		setGreeted(state, val) { state.greeted = val },
		setHeadersAuthorization(state) { state.headers.Authorization = 'Bearer ' + localStorage.token },
		setHeaderModule(state, headerModule) { 
			state.headerModule.id = headerModule.id
			state.headerModule.titleModule = headerModule.titleModule
			state.headerModule.subTitleModule = headerModule.subTitleModule
			state.headerModule.favorite = headerModule.favorite
		},
		setHistory(state, router) { state.history.push(router) },
		setHistoryInput(state, str) { state.historyInput.push(str) },
		setHistoryInputEmpty(state) { state.historyInput = [] },
		setInitialized(state, value) { state.initialized = value },
		setIconClassLockScreen(state, iconClass) { state.iconClassLockScreen = iconClass },
		setMenuLeft(state, menuAction) { state.menuLeft = menuAction },
		setMessageLockScreen(state, msg) { state.messageLockScreen = ' ' + msg },
		setRole(state, role) { state.role = role },
		setSocket(state, socket) { state.io = socket },
		setSocketioConnect(state, val) { state.socketioConnect = val },
		setSubTitleModule(state, text) { state.headerModule.subTitleModule = text },
		setTextColorLockScreen(state, textColor) { state.textColor = textColor },
		setTitleModule(state, text) { state.headerModule.titleModule = text },
		setToken(state, token) { state.token = token },
		setWeb(state, url) { state.web = url },
	},
	actions: {
		getMenuLeft: async function ({ commit }) {
		}
	},
	getters: {
		getInitialized: state => { return state.initialized },
		getHistoryInput: state => { return state.historyInput },
		getCommands: state => { 
			let list = []
			state.commandSystem.forEach(element => {
				list.push(element)
			});
			state.commandGeneral.forEach(element => {
				list.push(element)
			});
			state.commandModule.forEach(element => {
				list.push(element)
			});
			return list
		},
	},
	modules: {
		socketio,
		socketFacturacionCL,
		config: Config,
		user: User,
	}
})
